// extracted by mini-css-extract-plugin
module.exports = {"button":"NavPanelIconButton_button__2Xk3J","left":"NavPanelIconButton_left__3TO6F"};